import type { FC } from 'react'
import React from 'react'
import styled from '@emotion/styled'

import Button from '@segment/matcha/components/Button'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import LogoTiles from '@segment/templates/LogoTiles'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const copy = {
  heading: `Learn how our solutions can help accelerate
your time to value with Segment`,
}

const button = {
  text: `Get a demo`,
  url: `/demo/`,
}

const TimeToValue: FC = () => {
  const pageConfig = usePageConfig()

  return (
    <>
      <Copy>
        <CopyTextBase centered={true}>
          <StyledCopyTextHeading tag="h3" variant="h2">
            {copy.heading}
          </StyledCopyTextHeading>
          <ButtonWrapper>
            <StyledButton
              aria-label="Demo Button"
              size="large"
              color="primary"
              variant="filled"
              tag="a"
              href={getAbsoluteUrl(button.url, pageConfig)}
            >
              {button.text}
            </StyledButton>
          </ButtonWrapper>
        </CopyTextBase>
      </Copy>

      <LogoTiles />
    </>
  )
}

const Copy = styled.div`
  display: grid;
  justify-content: center;
  row-gap: 40px;
  padding: 0 20px;

  ${({ theme }) => theme.breakpoints.up(`md`)} {
    padding: 80px 80px 80px;
  }
`

const StyledCopyTextHeading = styled(CopyText.Heading)`
  ${({ theme }) => theme.breakpoints.up(`md`)} {
    max-width: 845px;
  }
`

const ButtonWrapper = styled.div`
  padding-top: 24px;
`

const StyledButton = styled(Button)`
  ${({ theme }) => theme.breakpoints.down(`sm`)} {
    width: 100%;
  }
`

export default TimeToValue
